import { render, staticRenderFns } from "./table_form.vue?vue&type=template&id=6bd270a6&scoped=true&"
import script from "./table_form.vue?vue&type=script&lang=js&"
export * from "./table_form.vue?vue&type=script&lang=js&"
import style0 from "./table_form.vue?vue&type=style&index=0&id=6bd270a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd270a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd270a6')) {
      api.createRecord('6bd270a6', component.options)
    } else {
      api.reload('6bd270a6', component.options)
    }
    module.hot.accept("./table_form.vue?vue&type=template&id=6bd270a6&scoped=true&", function () {
      api.rerender('6bd270a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_policy-copy/form/promotion_product/table_form.vue"
export default component.exports